import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Search, ArrowLeft } from 'lucide-react';
import SEOHead from '../components/SEOHead';

const NotFoundPage: React.FC = () => {
  return (
    <>
      <SEOHead
        title="Seite nicht gefunden - 404"
        description="Die angeforderte Seite konnte nicht gefunden werden. Kehren Sie zur Startseite zurück oder nutzen Sie unsere Navigation."
        noIndex={true}
      />
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-gray-100 flex items-center justify-center px-4">
        <div className="max-w-2xl w-full text-center">
          <div className="mb-8">
            <h1 className="text-9xl font-bold text-[#2574B5] mb-4">404</h1>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
              Seite nicht gefunden
            </h2>
            <p className="text-xl text-gray-600 mb-8">
              Die von Ihnen gesuchte Seite existiert leider nicht oder wurde verschoben.
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-8 mb-8">
            <div className="flex items-center justify-center mb-6">
              <Search className="h-12 w-12 text-gray-400" />
            </div>
            <h3 className="text-xl font-semibold text-gray-800 mb-4">
              Was können Sie jetzt tun?
            </h3>
            <ul className="text-left text-gray-600 space-y-3 max-w-md mx-auto">
              <li className="flex items-start">
                <span className="text-[#2574B5] mr-2">•</span>
                <span>Überprüfen Sie die URL auf Tippfehler</span>
              </li>
              <li className="flex items-start">
                <span className="text-[#2574B5] mr-2">•</span>
                <span>Nutzen Sie die Navigation oben, um zur gewünschten Seite zu gelangen</span>
              </li>
              <li className="flex items-start">
                <span className="text-[#2574B5] mr-2">•</span>
                <span>Kehren Sie zur Startseite zurück</span>
              </li>
            </ul>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              className="inline-flex items-center justify-center bg-[#2574B5] hover:bg-blue-700 text-white font-medium py-3 px-8 rounded-lg transition-colors duration-300"
            >
              <Home className="h-5 w-5 mr-2" />
              Zur Startseite
            </Link>
            <button
              onClick={() => window.history.back()}
              className="inline-flex items-center justify-center bg-white hover:bg-gray-50 text-gray-800 font-medium py-3 px-8 rounded-lg border border-gray-300 transition-colors duration-300"
            >
              <ArrowLeft className="h-5 w-5 mr-2" />
              Zurück
            </button>
          </div>

          <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-4 text-sm">
            <Link
              to="/faq"
              className="bg-white hover:bg-gray-50 p-4 rounded-lg border border-gray-200 transition-colors"
            >
              <h4 className="font-semibold text-gray-800 mb-1">FAQ</h4>
              <p className="text-gray-600">Häufige Fragen</p>
            </Link>
            <Link
              to="/registrieren"
              className="bg-white hover:bg-gray-50 p-4 rounded-lg border border-gray-200 transition-colors"
            >
              <h4 className="font-semibold text-gray-800 mb-1">Registrierung</h4>
              <p className="text-gray-600">Jetzt anmelden</p>
            </Link>
            <Link
              to="/login"
              className="bg-white hover:bg-gray-50 p-4 rounded-lg border border-gray-200 transition-colors"
            >
              <h4 className="font-semibold text-gray-800 mb-1">Login</h4>
              <p className="text-gray-600">Zum Kursbereich</p>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFoundPage;
